export const RISK_BADGE = {
  "Bajo": "bg-risk-low/10 text-risk-low border-risk-low/30",
  "Medio": "bg-risk-medium/10 text-risk-medium border-risk-medium/30",
  "Medio-Alto": "bg-risk-medhigh/10 text-risk-medhigh border-risk-medhigh/30",
  "Alto": "bg-risk-high/10 text-risk-high border-risk-high/30",
  "Crítico": "bg-risk-critical/10 text-risk-critical border-risk-critical/30",
};

export const RISK_DOT = {
  "Bajo": "bg-risk-low", "Medio": "bg-risk-medium", "Medio-Alto": "bg-risk-medhigh",
  "Alto": "bg-risk-high", "Crítico": "bg-risk-critical",
};

export const RISK_HSL = {
  "Bajo": "hsl(152 60% 30%)", "Medio": "hsl(40 85% 38%)", "Medio-Alto": "hsl(27 88% 42%)",
  "Alto": "hsl(10 74% 46%)", "Crítico": "hsl(350 74% 38%)",
};

export const STAGE_BADGE = {
  "Detección": "bg-muted text-muted-foreground border-border",
  "Registro": "bg-secondary text-secondary-foreground border-border",
  "Evaluación": "bg-risk-medium/10 text-risk-medium border-risk-medium/25",
  "Decisión": "bg-primary/8 text-primary border-primary/25",
  "Piloto": "bg-chart-2/10 text-accent border-accent/25",
  "Producción": "bg-accent/10 text-accent border-accent/30",
  "Monitoreo": "bg-primary/8 text-primary border-primary/20",
  "Reevaluación": "bg-risk-medhigh/10 text-risk-medhigh border-risk-medhigh/25",
  "Retirada": "bg-muted text-muted-foreground border-border",
};

export const STATUS_BADGE = {
  "Pendiente": "bg-muted text-muted-foreground border-border",
  "En curso": "bg-risk-medium/10 text-risk-medium border-risk-medium/25",
  "Bloqueada": "bg-risk-high/10 text-risk-high border-risk-high/25",
  "Completada": "bg-accent/10 text-accent border-accent/25",
  "Vencida": "bg-risk-critical/10 text-risk-critical border-risk-critical/25",
  "Implementado": "bg-accent/10 text-accent border-accent/25",
  "Aprobado": "bg-accent/10 text-accent border-accent/25",
  "Aprobada": "bg-accent/10 text-accent border-accent/25",
  "Aprobada con condiciones": "bg-risk-medium/10 text-risk-medium border-risk-medium/25",
  "Rechazada": "bg-risk-critical/10 text-risk-critical border-risk-critical/25",
  "En votación": "bg-primary/8 text-primary border-primary/25",
  "En revisión": "bg-risk-medium/10 text-risk-medium border-risk-medium/25",
  "Borrador": "bg-muted text-muted-foreground border-border",
  "Vencido": "bg-risk-high/10 text-risk-high border-risk-high/25",
  "Vigente": "bg-success/10 text-success border-success/25",
  "No gobernada": "bg-risk-critical/10 text-risk-critical border-risk-critical/25",
  "En análisis": "bg-risk-medium/10 text-risk-medium border-risk-medium/25",
  "En registro": "bg-primary/8 text-primary border-primary/25",
  "Registrada": "bg-success/10 text-success border-success/25",
  "Bloqueada (Shadow)": "bg-risk-high/10 text-risk-high border-risk-high/25",
  "Excepción autorizada": "bg-secondary text-secondary-foreground border-border",
  "Activo": "bg-success/10 text-success border-success/25",
  "En evaluación": "bg-risk-medium/10 text-risk-medium border-risk-medium/25",
};

export const ROLE_LABEL = {
  admin: "Administrador", evaluador: "Evaluador", comite: "Comité de IA", lector: "Lector",
};

export const PRIORITY_BADGE = {
  "Crítica": "bg-risk-critical/10 text-risk-critical border-risk-critical/25",
  "Alta": "bg-risk-high/10 text-risk-high border-risk-high/25",
  "Media": "bg-risk-medium/10 text-risk-medium border-risk-medium/25",
  "Baja": "bg-muted text-muted-foreground border-border",
};

export const REEVAL_TRIGGERS = [
  "Cambio de proveedor", "Cambio de modelo", "Nueva versión", "Cambio de finalidad",
  "Aumento significativo de volumen", "Nueva categoría de datos", "Nuevo departamento",
  "Incidente de seguridad", "Resultado de monitoreo", "Vencimiento anual",
  "Cambio regulatorio", "Cambio del nivel de riesgo",
];

export const DOC_TYPES = [
  "Evaluación de privacidad", "Revisión de seguridad", "Validación clínica", "Arquitectura",
  "Documentos del proveedor", "Contractual", "Evidencia de controles", "Plan de monitoreo", "Caso de negocio",
];

export const METRIC_TYPES = [
  "Ahorro de tiempo", "Ahorro de costos", "Productividad", "Adopción", "Usuarios activos",
  "Satisfacción", "Calidad", "Disminución de errores", "Reducción de riesgo", "Ingresos",
  "Cost avoidance", "Tiempo de respuesta", "Impacto clínico", "Impacto operacional",
];

// Estados de un beneficio esperado (objetivo) de la iniciativa.
export const BENEFIT_STATUSES = ["Planeado", "En curso", "Logrado", "En riesgo"];

// Estados de un hito de seguimiento de la iniciativa.
export const MILESTONE_STATUSES = ["En desarrollo", "En paralelo", "En producción", "Completado"];

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("es-CL", { day: "2-digit", month: "short", year: "numeric" });
  } catch { return "—"; }
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("es-CL", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch { return "—"; }
}

export function exportCSV(rows, filename) {
  if (!rows?.length) return;
  const keys = Object.keys(rows[0]).filter((k) => typeof rows[0][k] !== "object");
  const esc = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;
  const csv = [keys.join(";"), ...rows.map((r) => keys.map((k) => esc(r[k])).join(";"))].join("\n");
  const blob = new Blob(["\ufeff" + csv], { type: "text/csv;charset=utf-8" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
}
